module.exports = __webpack_public_path__ + "img/王称堌镇.594ac593.png";